const roundToHalf = (years: number) => Math.round(years * 2) / 2;

export default roundToHalf;
